import { AuthStrategyProvider, useOtpStrategy } from '@/contexts/authStrategy';

// why: shared by _app and both mission pages, which each carried an identical copy.
export const OtpAuthWrapper = ({ children }) => {
  const strategy = useOtpStrategy();
  return <AuthStrategyProvider strategy={strategy}>{children}</AuthStrategyProvider>;
};
